import React, { useState } from 'react';
import api from '../services/api';
import Button from '../common/Button';
import Input from '../common/Input';
import Toast from '../common/Toast';

const AddVehicle = () => {
  const [form, setForm] = useState({ plate_number: '', model: '', capacity: '', route_description: '' });
  const [toast, setToast] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/owner/vehicles', form);
      setToast({ message: 'Vehicle added successfully!', type: 'success' });
      setForm({ plate_number: '', model: '', capacity: '', route_description: '' });
    } catch (err) {
      setToast({ message: 'Failed to add vehicle', type: 'error' });
    }
  };

  return (
    <div className="glass-card fade-in">
      <h2>Register New Vehicle</h2>
      <form onSubmit={handleSubmit}>
        <Input label="Plate Number" value={form.plate_number} onChange={e => setForm({...form, plate_number: e.target.value})} required />
        <Input label="Model" value={form.model} onChange={e => setForm({...form, model: e.target.value})} />
        <Input label="Capacity" type="number" value={form.capacity} onChange={e => setForm({...form, capacity: e.target.value})} />
        <Input label="Route Description" value={form.route_description} onChange={e => setForm({...form, route_description: e.target.value})} />
        <Button type="submit">Add Vehicle</Button>
      </form>
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};
export default AddVehicle;